/** @format */

import { Warranty } from '@shared/data-access/interfaces';
import { SelectedWarranty } from '@pdp/data-access/interfaces';

export const getSelectedWarranty = (
	planSku: string | null | undefined,
	availableWarranties: Warranty[]
): SelectedWarranty => {
	if (!planSku) {
		return null;
	}
	const warranty = availableWarranties.find((warranty) => warranty.planSku === planSku);
	if (!warranty) {
		return null;
	}
	return {
		planSku: warranty.planSku,
		planLength: warranty.planLength
	};
};
